import { render, staticRenderFns } from "./MyStartups.vue?vue&type=template&id=61369d0e&scoped=true&"
import script from "./MyStartups.vue?vue&type=script&lang=js&"
export * from "./MyStartups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61369d0e",
  null
  
)

export default component.exports